// extracted by mini-css-extract-plugin
export default {"wrapper":"FilmLayout_wrapper__iypMA","content":"FilmLayout_content__YDa6o","go-top-btn":"FilmLayout_go-top-btn__G8v-+"};